import { http } from '@/http/axios.js';

// 渠道列表
export function getChannelListAPI(params) {
  return http({
    url: '/adminapi/channel/page',
    method: 'get',
    params
  })
}
// 渠道详情
export function getChannelDetailAPI(id) {
  return http({
    url: '/adminapi/channel/detail',
    method: 'get',
    params: { id }
  })
}
// 删除渠道
export function deleteChannelAPI(id) {
  return http({
    url: '/adminapi/channel/delete',
    method: 'post',
    data: { id }
  })
}
// 新增渠道
export function addChannelAPI(data) {
  return http({
    url: '/adminapi/channel/add',
    method: 'post',
    data
  })
}
// 编辑渠道
export function editChannelAPI(data) {
  return http({
    url: '/adminapi/channel/edit',
    method: 'post',
    data
  })
}
// 上下架
export function editStatusAPI(data) {
  return http({
    url: '/adminapi/channel/status/edit',
    method: 'post',
    data
  })
}
